import { UPDATE_OVERLAYS } from '../types/overlays';

// eslint-disable-next-line import/prefer-default-export
export const updateOverlays = (overlays) => ({
  type: UPDATE_OVERLAYS,
  payload: overlays,
});
